export default [
    {
        comment: '',
        error_id: 'ST 02',
        data: [
            {cross_section: '4420', multiple: true, number: 1, missing_methods: 'Energy, Momentum, Use Highest Energy Answer', },
            {cross_section: '5505', multiple: false, number: 1, missing_methods: 'Energy, Momentum, Use Highest Energy Answer', },
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'ST 03',
        data: [
            {cross_section: '4420', ratio: 0.95},
            {cross_section: '5505', ratio: 0.95},
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'ST 04',
        data: [
            {cross_section: '1240', ratio: 0.95},
            {cross_section: '3505', ratio: 0.95},
        ]
    }
]